/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {

    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();

    // Adds Flex Video to YouTube and Vimeo Embeds
    jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
        if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
            jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
        } else {
            jQuery(this).wrap("<div class='responsive-embed'/>");
        }
    });

    jQuery('#testimonials').owlCarousel({
        loop: false,
        margin: 30,
        nav: false,
        dots: true,
        autoplay: true,
        autoplayTimeout: 10000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1
            },
            300: {
                items: 1
            },
            600: {
                items: 1
            },
            900: {
                items: 1
            },
            1200: {
                items: 1
            }
        }
    });

    // Close Active Accordion on Load
    /* if(jQuery('#faq_help_page-tabs').hasClass('accordion'))
    {
        jQuery('#faq_help_page-tabs li.is-active .accordion-content').css('display', 'none');
        jQuery('#faq_help_page-tabs li.is-active').toggleClass('is-active');
    } */
});